import { Component, Inject, Input, OnInit, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { FunctionService } from 'vhobjects-service/src/services';
import { isPlatformBrowser } from '@angular/common';
import { ThemeService } from 'vhobjects-service';
import { ChooseIconComponent } from 'vhobjects-service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'atw-booking-selector-config',
  templateUrl: './booking-selector-config.component.html',
  styleUrls: ['./booking-selector-config.component.scss']
})
export class AtwBookingSelectorConfig implements OnInit {
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  // @Input() id_subproject : any;
  @Input() type: any;
  @Input() blocks_of_page: any; // là dữ liệu blocks_of_page từ database
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any; // lưu phần tử được chọn của mảng style_field để hiện thị phần mở rộng cấu hình
  backgroundColor: any = [];
  styles_field = [
    {
      title: 'dieu_chinh_noi_dung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien',
      index: 2,
    },
    {
      title: 'hieu_ung',
      index: 3,
    },
    {
      title: 'nang_cao',
      index: 4,
    },
    {
      title: 'nen_bieu_tuong',
      index: 5,
    },
    {
      title: 'dieu_chinh_vien',
      index: 6,
    },
    {
      title: 'dieu_chinh_vien',
      index: 7,
    },
    {
      title: 'dieu_chinh_vien',
      index: 8,
    },
    {
      title: 'dieu_chinh_vien',
      index: 9,
    },
  ];
  width: number = 0;
  height: number = 0;
  customize = [];

  constructor(
    private vhEventMediator: VhEventMediator,
    public functionService: FunctionService,
    private vhQueryAutoWeb: VhQueryAutoWeb,
    public themeService: ThemeService,
    private dialog: MatDialog,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit(): void {
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    this.ensureStyleBuckets();
    setTimeout(() => {
      if (isPlatformBrowser(this.platformId)) {
        this.width = document.getElementById(this.objectChoosing._id).clientWidth;
        this.height = document.getElementById(this.objectChoosing._id).clientHeight;
      }
    }, 0);
  }

  ensureStyleBuckets() {
    if (!this.class) return;

    const defaultBuckets = [
      'date-popover',
      'range-picker',
      'room-popover',
      'room-popover__header',
      'room-popover__room-title',
      'room-popover__label',
      'room-popover__value',
      'room-popover__note',
      'room-popover__counter-button',
      'room-popover__counter-icon',
    ];

    defaultBuckets.forEach((key) => {
      if (!this.class[key]) this.class[key] = {};
    });
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean; } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
    menu10: false,
    menu11: false,
  };
  openMapSub: { [name: string]: boolean; } = { menu1: false, menu2: false };
  openHandler(value: string, isSub = false): void {
    const targetMap = isSub ? this.openMapSub : this.openMap;
    Object.keys(targetMap).forEach(key => {
      if (key !== value) targetMap[key] = false;
    });
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['booking-selector']['width'] = event.width + 'px';
    if (event.height) this.class['booking-selector']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
    this.updateClass();
  }

  updateClassAndConfig() {
    if (this.type == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = [];
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing);
      if (!this.objectChoosing['fieldUpdate'].includes(this.device + '_class')) this.objectChoosing['fieldUpdate'].push(this.device + '_class');
      if (!this.objectChoosing['fieldUpdate'].includes(this.device + '_config')) this.objectChoosing['fieldUpdate'].push(this.device + '_config');
      return;
    }
    this.updateFields({
      [this.device + '_config']: this.config,
      [this.device + '_class']: this.class,
    });
  }

  /**
  * Hàm này dùng để mở rộng phần cấu hình.
  * @param field_text : trả về phần tử được chọn của mảng style_field
  */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
  * Cập nhật staticdata vào database.
  */
  updateStaticData() {
    // Gọi hàm truy vấn cơ sở dữ liệu ở đây
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
        // console.log('updateObject', bool);
      });
  }

  /**
 * Cập nhật Setups vào database.
 */
  updateSetups() {

    // Gọi hàm truy vấn cơ sở dữ liệu ở đây
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, { setups: this.objectChoosing.setups })
      .then((bool) => {
        // console.log('updateObject', bool);
      });
  }

  /**
   *Hàm update config vào database.
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      [this.device + '_config']: this.config,
    });
  }
  /**
   * Hàm update object vào database.
   */
  updateFields(value) {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, value)
      .then((bool: any) => { });
  }
  /**
   *Hàm update class vào database.
   */
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => { });
  }

  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   *
   */
  addGradient(value) {
    if (/\#/.test(value)) {
      const gradient = this.config['background-color'];
      gradient[`gradient_arr`].push(
        `rgba(${this.hexToRGB(value)}, ${gradient.value_range})`
      );
      this.updateBackgroundRgb();
    }
  }
  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index) {
    if (this.config['background-color'][`gradient_arr`].length > 1) {
      this.config['background-color'][`gradient_arr`].splice(index, 1);
      this.updateBackgroundRgb()
    }
  }

  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }

  // hàm cập nhật background linear-gradient
  updateBackgroundRgb() {
    if (this.config['background-color'].gradient_check) {
      this.class['booking-selector']['background-image'] = "linear-gradient(" + this.config['background-color']['gradient_direction'] + this.config['background-color']['gradient_arr'] + ")";
    }
    else {
      this.class['booking-selector']['background-image'] = "none";
    }
    this.updateObject();
  }

  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
        // console.log('updateObject', bool);
      })
  }

  /** Hàm này cho phép chọn options direction của màu gradient
       * @param direction : trả về hướng phối màu được chọn
       * @param event : trả về element được active
       */
  chooseOption(direction, event) {
    if (isPlatformBrowser(this.platformId)) {
      // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
      this.config['background-color'].gradient_type = direction.type;
      this.config['background-color'].gradient_direction = direction.direction;
      this.class['booking-selector']['background-image'] = this.config['background-color'].gradient_type + '(' + this.config['background-color'].gradient_direction + this.config['background-color'].gradient_arr.join(',') + ')'
      this.updateConfig();
      this.updateClass();
    }
  }

  /**Hàm này dùng để click chọn màu nền của danh sách màu.
       * @param bgColor : trả về màu được chọn
       * @param event : trả về element được active
       */
  chooseBg(bgColor, event, classBg) {
    if (isPlatformBrowser(this.platformId)) {
      // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
      // Lấy ra element màu được click từ tham số event trả về.
      var activeGradient = document.querySelector(
        '.container-color .active'
      ) as HTMLElement;
      if (activeGradient) activeGradient.classList.remove('active');
      event.currentTarget.classList.add('active');
      // Lấy giá trị màu được click từ tham số bgColor.
      //  Chuyển đổi màu được click thành mã rgb , thêm alpha vào mã rgb và lưu vào database.
      const data_background = this.class[classBg]
      data_background['background-color'] = bgColor.bgColor;
      data_background['background-color'] = `rgba(${this.hexToRGB(data_background['background-color'])}, ${this.config['background-color'].value_range})`;
      this.updateObject();
    }
  }

  openDialogChooseIcon(config) {
    const dialogRef = this.dialog.open(ChooseIconComponent, {
      width: '80vw',
      height: '70vh',
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        config.icon_name = result.icon;
        this.updateConfig();
      }
    });
  }

  sections = [
    {
      title: 'thanh_tim_kiem',
      fields: [
        {
          label: 'nhan_khach_san',
          model: 'hotel_selector_label'
        },
        {
          label: 'placeholder_khach_san',
          model: 'hotel_selector_placeholder'
        },
        {
          label: 'nhan_ngay_nhan_phong',
          model: 'departure_date_label'
        },
        {
          label: 'nhan_so_khach',
          model: 'guest_selector_label'
        },
        {
          label: 'nut_tim_kiem',
          model: 'btn_search_content'
        }
      ]
    },

    {
      title: 'bo_dem_phong_khach',
      fields: [
        {
          label: 'don_vi_phong',
          model: 'room_unit'
        },
        {
          label: 'don_vi_nguoi_lon',
          model: 'adult_unit'
        },
        {
          label: 'don_vi_tre_em',
          model: 'children_unit'
        },
        {
          label: 'tieu_de_popover_phong',
          model: 'room_popover_title'
        },
        {
          label: 'nhan_nguoi_lon',
          model: 'adults_label'
        },
        {
          label: 'nhan_tre_em',
          model: 'children_label'
        },
        {
          label: 'tieu_de_muc_phong',
          model: 'room_item_title'
        }
      ]
    }
  ];

}
